/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { colors } from "../colors";
import { StyledText } from "../../assets/typography/typography";
import { breakpoints } from "../breakpoints";

type Props = {
  title: string;
  subtitle?: string;
  subtitleComponent?: React.ReactNode;
  children?: React.ReactNode;
  titleButton?: React.ReactNode;
};

const pageHeaderStyle = css`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 32px;
  padding: 24px 24px 8px 24px;
  align-items: center;
  ${breakpoints.tablet} {
    flex-direction: column;
    gap: 16px;
  }
`;

const leftPageHeaderStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const rightPageHeaderStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
  ${breakpoints.tablet} {
    flex-direction: column;
    gap: 16px;
  }
`;

const titleWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const PageHeader = ({
  title,
  subtitle,
  children,
  titleButton,
  subtitleComponent,
}: Props) => {
  return (
    <div css={pageHeaderStyle}>
      <div css={leftPageHeaderStyle}>
        <div css={titleWrapper}>
          <StyledText
            color={colors.textPrimary}
            className="bodyHeaderOneSemi mb-0"
          >
            {title}
          </StyledText>
          {titleButton && titleButton}
        </div>
        {subtitle && (
          <StyledText
            color={colors.textPrimary}
            className="bodyTextRegular mb-0"
          >
            {subtitle}
          </StyledText>
        )}
        {subtitleComponent && subtitleComponent}
      </div>
      <div css={rightPageHeaderStyle}>{children}</div>
    </div>
  );
};
